import { ExtendedAttribute } from './extended-attribute';

export class EditExtendedAttributeCommand {
    visible: boolean;
    editable: boolean;
    shared_by_default: boolean;
    sort: number;
    options_enabled: boolean;
    mandatory?: boolean;
    enabled_for?: {
        course: true;
        program: true;
        e_learning: true;
    };

    constructor(model: ExtendedAttribute) {
        this.visible = model.visible;
        this.editable = model.editable;
        this.shared_by_default = model.sharedByDefault;
        this.sort = model.sort;
        this.options_enabled = model.optionsEnabled;
        this.mandatory = model.mandatory;
        if (model.enabledFor) {
            this.enabled_for = {
                course: model.enabledFor.course,
                program: model.enabledFor.program,
                e_learning: model.enabledFor.eLearning,
            };
        }
    }
}
